import { createFileRoute } from '@tanstack/react-router';
import { McpSettingsPage } from '@/features/mcp/McpSettingsPage';
export const Route = createFileRoute('/_authenticated/admin/mcp')({ component: McpSettingsPage });
